import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );

export default class {

    constructor(options) {

        // OPTIONS
        this.defaults = {

            $el: undefined,

			imageTranslationStart : [
				"0",
				"32vw",
				"43vw",
				"8vw",
				"19vw",
				"43vw",
				"53vw",
				"13vw"
			],

			imageTranslationEnd : [
				"0",
				"-32vw",
				"-43vw",
				"-8vw",
				"-19vw",
				"-43vw",
				"-53vw",
				"-13vw"
			]

        }

		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace  = 'image_cloud';

		// DOM ELEMENT !!!!!!!!!!
		this.$el = this.options.$el;

		// vars
		/*
		this.$win = $(window);
		this.$doc = $(document);
		this.$html = $('html');
		this.$body = $( 'body' );
		*/

		this.ids = [];

		// init!!!!
		this.init( true );

    }

	init( b ){		
		this.initScrollTrigger(b);
	}

	initScrollTrigger(b){
		if ( b ){
			let $imgs = this.$el.find( 'img' ), $img, start, end;
			if ( $imgs.length > 0 ){
				$imgs.each( ( i, el ) => {

					$img  	= $(el);
					start 	= this.options.imageTranslationStart[ i ];
					end 	= this.options.imageTranslationEnd[ i ];

					if ( start && end ){

						gsap.fromTo( $img, { y: start },
							{
								y: end,
								ease: "none",
								scrollTrigger: {
									trigger: this.$el,
									duration: '200%',
									// start: "top bottom", // the default values
									// end: "bottom top",
									scrub: true,
									markers: false,
									id: this.getID(),
									// toggleClass: 'in-view'
								} 
							}
						)						
					}
				})
			}
		}
		else{
			this.destroyScrollTriggers();
		}
	}

	//--------------------- UTILS ----------------------//
	getID(){
		const id = 'id_' + this.namespace + '_' + this.ids.length;
		this.ids.push( id );
		return id;
	}

	killById( id ){
		if ( ScrollTrigger.getById( id ) ){
			ScrollTrigger.getById( id ).kill();
		}
	}

	destroyScrollTriggers(){
      	if ( this.ids.length ){
      		let i = this.ids.length;
      		while( i-- ){
      			this.killById( this.ids[i] );
      		}
      		this.ids = [];
      	}
	}

    destroy(){
		this.init( false );
		this.$el.removeData();
    }

}
